import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { AgencyUserGridViewModel } from '@program-suite/data-common';

@Injectable({
  providedIn: 'root',
})
export class AgencyUserGridService {
  http = inject(HttpClient);

  /**
   * get agency grid
   * @returns 200 - OK(AgencyUsersGridViewModel)
   * @throws Error if fails
   */
  async getAgencyUserGrid(params: any): Promise<AgencyUserGridViewModel> {
    try {
      return await firstValueFrom(this.http.get('Agency/agency-users', {params, responseType: 'json' }));
    } catch (error) {
      throw new Error('Something went wrong, please try again');
    }
  }
}
